function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a5f847d7-0991-4d5b-9d5c-5c4044144d2a{fill:none;}.a5f847d7-0991-4d5b-9d5c-5c4044144d2a,.ef4e5123-5d66-4a6e-8a44-4728b49273c6{stroke:#5a7a7d;stroke-linecap:round;stroke-linejoin:round;stroke-width:50px;}.ef4e5123-5d66-4a6e-8a44-4728b49273c6{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a5f847d7-0991-4d5b-9d5c-5c4044144d2a",
  d: "M377.51,346l-14.61,1.16c-32.37,2.53-56.62,29.66-54,60.29L327.1,614.65c2.7,30.6,31.33,53.58,63.68,51l14.64-1.14c32.31-2.53,56.61-29.67,53.92-60.3L441.19,397C438.5,366.4,409.83,343.4,377.51,346Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a5f847d7-0991-4d5b-9d5c-5c4044144d2a",
  d: "M526.31,339.75,511.7,341a59.25,59.25,0,0,0-54,63.75l18.17,219.16a59.21,59.21,0,0,0,63.68,54l14.63-1.21a59.22,59.22,0,0,0,53.92-63.76L590,393.75A59.2,59.2,0,0,0,526.31,339.75Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "a5f847d7-0991-4d5b-9d5c-5c4044144d2a",
  d: "M237.66,388.51,223,389.62c-32.34,2.44-56.6,28.75-53.94,58.41L187.26,648.8c2.69,29.66,31.33,51.93,63.7,49.46l14.58-1.11c32.35-2.46,56.64-28.73,53.93-58.4L301.32,438C298.66,408.3,270,386.05,237.66,388.51Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "a5f847d7-0991-4d5b-9d5c-5c4044144d2a",
  d: "M90.49,450.29,76,452.16c-32.19,4.15-54.86,32.13-50.44,62.17l23.26,157.9c4.43,30.09,34.34,51.27,66.5,47.13l14.53-1.86c32.15-4.14,54.83-32.13,50.4-62.18L157,497.42C152.58,467.36,122.63,446.14,90.49,450.29Z"
});

var _ref7 = /*#__PURE__*/React.createElement("polyline", {
  className: "a5f847d7-0991-4d5b-9d5c-5c4044144d2a",
  points: "26 519.07 44.3 827.15 148.48 1055.71"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "ef4e5123-5d66-4a6e-8a44-4728b49273c6",
  d: "M358.09,930.9C370.43,808,534.46,753.41,534.46,753.41L548,696.31,470.4,642.36c-30.49-24.74-34.26-66.47-14-102.82,15.92-28.45,48.86-17,48.86-17S650.7,558.26,682.12,579c67.45,44.37,17.94,213.69-9.45,265.49s-104.58,211.28-104.58,211.28l-16.79,75.81"
});

function SvgRight0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eef743b5-8697-4b71-aae3-e5d97e6ea111",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 741 1157.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight0);
export default __webpack_public_path__ + "static/media/right-0.2b4e88d6.svg";
export { ForwardRef as ReactComponent };